import { globals } from '../../globals'

// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_DATA_FOR_SHARING = 'UPDATE_DATA_FOR_SHARING'

export const GET_USERS_LIST_START = 'GET_USERS_LIST_START'
export const USERS_LIST_FETCHED = 'USERS_LIST_FETCHED'
export const GET_USERS_LIST_FAILED = 'GET_USERS_LIST_FAILED'

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  updateSharingData,
  getUsersListForSharing
}

export function updateSharingData (location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_DATA_FOR_SHARING,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    }
  }
}

export function getUsersListForSharing (clientId) {
  return (dispatch) => {
    dispatch({ type: GET_USERS_LIST_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/simpleuserlist?clientId=${clientId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: GET_USERS_LIST_FAILED,
          payload: {
            json: [],
          },
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: USERS_LIST_FETCHED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_USERS_LIST_FAILED })
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA_FOR_SHARING] : (state, action) => {
    if (action.location.page !== undefined) {
      return state
    }
    switch (action.valueType) {
      case 'ch': {
        // mark single checkbox as checked
        const { field } = action.location
        const { value } = action.payload
        const resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue[field].selected, ...value]
          : [...state.formDataValue[field].selected, value]
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              selected: resultedSelectedArray,
            }
          }
        }
      }
      case 'ch_uncheck': {
        // uncheck single checkbox
        const { field } = action.location
        const { value } = action.payload
        let resultedSelectedArray = state.formDataValue[field].selected
        if (Array.isArray(value)) {
          value.forEach(item => {
            resultedSelectedArray = resultedSelectedArray.filter(function (element) {
              return element !== item
            })
          })
        } else {
          const idIndex = state.formDataValue[field].selected.indexOf(value)
          resultedSelectedArray = [
            ...resultedSelectedArray.slice(0, idIndex),
            ...resultedSelectedArray.slice(idIndex + 1)
          ]
        }
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              selected: resultedSelectedArray,
            }
          }
        }
      }
      case 'radio':
      case 'switch':
      case 'select': {
        // radio button template
        const { field } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [action.location.field]: {
              ...state.formDataValue[field],
              radio: {
                ...state.formDataValue[field].radio,
                [value]: fieldValue,
              }
            }
          }
        }
      }
      case 'textinput' : {
        // set text value
        const { field } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [field]: {
              ...state.formDataValue[field],
              textValues: {
                ...state.formDataValue[field].textValues,
                [value]: fieldValue,
              }
            }
          }
        }
      }
    }
  },
  [GET_USERS_LIST_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [USERS_LIST_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        shareUsersList: json
      }
    }
  },
  [GET_USERS_LIST_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  renderData: {},
  formDataValue: {
    clientsDashboard: {
      selected: [],
      radio: {
        customList: 'List 1',
        shareWith: 'Share with a person',
        personShare: 'All'
      },
      textValues: {
        copyLink: '',
        addNew: ''
      }
    }
  },
}

export default function shareReportReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/shareReport.js